import { Tracker, Product, Action } from '@studyportals/datalake-event-tracker'
import RollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';

export default class DataTracker {
	private tracker: Tracker;

	private get userId(): number {
		const userElement: HTMLDivElement | null =
			document.querySelector('.js-enrolmentTool');
		const idAsString = userElement?.dataset.id;
		if (typeof idAsString !== 'string') {
			return 0;
		}

		const idAsNumber = parseInt(idAsString);
		return isNaN(idAsNumber) ? 0 : idAsNumber;
	}

	constructor() {
		this.tracker = new Tracker(Product.ACT_DASHBOARD);
	}

	public trackPageView(): void {
		const router = store.getters.router();
		this.track(
			Action.IMPRESSION,
			this.convertToSnakeCase(router.current),
			router.props.id.toLowerCase(),
			this.userId
		);
	}

	public trackDashboardClick(productNumber: string, isActive: boolean): void {
		this.track(
			Action.CLICK,
			isActive ? 'active_dashboard_click' : 'inactive_dashboard_click',
			productNumber.toLowerCase(),
			this.userId
		);
	}

	public trackRequestDemoClick(context: string): void {
		this.track(
			Action.CLICK,
			'request_demo_click',
			context.toLowerCase(),
			this.userId
		);
	}

	public trackLoadingSpeed(fullyReady: boolean): void {
		if (!this.isPerformanceFunctionalityAvailable()) {
			return;
		}

		this.track(
			Action.NON_INTERACTIVE,
			fullyReady ? 'page_fully_loaded' : 'page_initial_render',
			window.performance.now().toString(),
			this.userId
		);
	}

	public trackUserDetailsActiveDashboardsCount(): void {
		const activeDashboards = store.getters.activeDashboards();
		this.track(
			Action.NON_INTERACTIVE,
			'user_details_active_dashboards_count',
			activeDashboards.length.toString(),
			this.userId
		);
	}

	public trackHelpCentreClick(): void {
		this.track(
			Action.CLICK,
			'support_click',
			'help_centre',
			this.userId
		);
	}

	public trackContactSupportClick(): void {
		this.track(
			Action.CLICK,
			'support_click',
			'contact_support',
			this.userId
		);
	}

	private track(action: Action, label: string, property: string, value?: number): void {
		try {
			this.tracker.trackStructuredEvent(
				{
					action,
					label,
					property,
					value
				},
				Product.ACT_DASHBOARD,
				{
					enableSnowplow: false,
					enableGTM: true
				}
			);
		} catch (e) {
			RollbarOperator.triggerError(e as Error);
		}
	}

	private convertToSnakeCase(input: string): string {
		return input
			.replace(/-/g, '_')
			.toLowerCase();
	}

	private isPerformanceFunctionalityAvailable(): boolean {
		return typeof window.performance?.now === 'function';
	}
}
